<template>
    <div>
        <div class="username-selection">
            <div>
                <b-alert variant="success" :show="showSuccess" class="mb-3 mt-0 mx-0">
                    Your username has been saved.
                </b-alert>
                <b-alert variant="danger" :show="showError" class="mb-3 mt-0 mx-0">
                    <ul class="mb-0">
                        <li v-for="(error, prop) in errors" :key="prop">
                            {{ error[0] }}
                        </li>
                    </ul>
                </b-alert>
                
                <b-input-group prepend="@">
                    <b-input
                        v-model="username"
                        placeholder="Choose your username..."
                        ></b-input>
                </b-input-group>
                <small class="form-text text-muted mb-2">
                    Your username is your unique profile page address.  Because it forms
                    part of your page address it <b>can't contain spaces or special characters</b>.
                    You can change your username at any time, but please remember to update 
                    any links you may have going to it.
                </small>
                <button type="button" class="btn btn-success" @click="save" :disabled="isBusy">{{ btnText }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        },

        data() {
            let username = window.virtuoso.user.username ?? null;

            return {
                username: username,
                isBusy: false,
                showSuccess: false,
                showError: false,
                errors: '',
                btnText: 'Save',
            }
        },

        mounted() {
        },

        methods: {
            // Upload
            save() {
                this.isBusy = true;
                this.errors = null;
                this.showError = false;
                this.btnText = 'Please wait...';
                this.showSuccess = false;

                axios.post('/api/me/update-username', {
                    username: this.username,
                }).then((response) => {
                    this.reset();

                    Bus.$emit('usernameUpdated', {
                        'username': this.username,
                        'profileUrl': response.data.profileUrl,
                    });

                    window.virtuoso.user.username = this.username;
                    window.virtuoso.user.profileUrl = response.data.profileUrl;

                    this.showSuccess = true;
                }).catch((e) => {
                    this.showError = true;
                    this.errors = e.response.data.errors;
                    this.reset();
                });
            },

            // Reset form
            reset() {
                this.isBusy = false;
                this.btnText = 'Save';
            },
        }
    }
</script>